var Texture2d = (function () {
    function Texture2d(gl) {
        this.gl = gl;
        this.generate_mipmaps = false;
        this.texture_id = this.gl.createTexture();
    }
    Object.defineProperty(Texture2d.prototype, "id", {
        get: function () { return this.texture_id; },
        enumerable: true,
        configurable: true
    });
    ;
    ;
    Texture2d.prototype.bindTexture = function () {
        this.gl.bindTexture(this.gl.TEXTURE_2D, this.texture_id);
    };
    ;
    Texture2d.prototype.uploadTextureData = function (data) {
        this.bindTexture();
        this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA, this.gl.RGBA, this.gl.UNSIGNED_BYTE, data);
        this.gl.generateMipmap(this.gl.TEXTURE_2D);
    };
    ;
    Texture2d.prototype.allocateTextureStorage = function (width, height, generate_mipmaps) {
        if (generate_mipmaps === void 0) { generate_mipmaps = false; }
        this.bindTexture();
        this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA, width, height, 0, this.gl.RGBA, this.gl.FLOAT, null);
        if (generate_mipmaps) {
            this.generate_mipmaps = true;
            this.gl.generateMipmap(this.gl.TEXTURE_2D);
        }
    };
    ;
    Texture2d.prototype.beginRender = function () {
        this.gl.framebufferTexture2D(this.gl.FRAMEBUFFER, this.gl.COLOR_ATTACHMENT0, this.gl.TEXTURE_2D, this.id, 0);
    };
    ;
    Texture2d.prototype.finishRender = function () {
        if (this.generate_mipmaps) {
            this.gl.generateMipmap(this.gl.TEXTURE_2D);
        }
    };
    ;
    return Texture2d;
}());
export { Texture2d };
;
//# sourceMappingURL=texture-2d.js.map